var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.758,
    height: 24.062,
    viewBox: "0 0 13.758 24.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M12.035,4.147l9.1,9.105a1.712,1.712,0,0,0,2.429,0,1.734,1.734,0,0,0,0-2.436L13.253.5a1.716,1.716,0,0,0-2.371-.05L.5,10.81A1.72,1.72,0,1,0,2.93,13.246Z",
    transform: "translate(13.758) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.ec02d65b1a2ffd3c79f2cc7a2234541a.svg";
export { ForwardRef as ReactComponent };